import math from "./mathjs"

/**
 * 将字符串转换为千分位格式
 * @param amount 字符串格式的数字
 * @returns 千分位格式的字符串
 */
export function formatToThousands(amount: string, minPrecision = 2): string {
  const number = parseFloat(amount)
  if (isNaN(number)) {
    throw new TypeError("Invalid number")
  }

  // 先处理精度，不进行四舍五入
  const [intPart, decimalPart = ''] = number.toString().split('.')
  const truncatedDecimal = decimalPart.slice(0, minPrecision)
  const processedNumber = parseFloat(intPart + (truncatedDecimal ? '.' + truncatedDecimal : ''))

  return new Intl.NumberFormat("en-US", {
    minimumFractionDigits: minPrecision,
    maximumFractionDigits: minPrecision,
    useGrouping: true,
    roundingMode: 'trunc',
  }).format(processedNumber)
}

/**
 * 将人民币分转换为元，并保留两位小数
 * @param cents 人民币分
 * @param isFormatToThousands 是否转换为千分位
 * @param minPrecision 最小的精度
 * @param trim 是否去掉小数点后面冗余的0
 * @returns 转换后的人民币元字符串，保留两位小数
 */
export function convertCentsToYuan(cents: number, isFormatToThousands = false, minPrecision = 2, trim = false): string {
  const yuan = math.divide(cents, 100)
  // 将数字转为字符串，然后手动截断小数位
  const [intPart, decimalPart = ''] = math.format(yuan, { notation: "fixed", precision: 20 }).split('.')
  const truncatedDecimal = decimalPart.slice(0, minPrecision)
  const truncatedYuan = `${intPart}${truncatedDecimal ? '.' + truncatedDecimal : ''}`

  if (isFormatToThousands) {
    const temp = formatToThousands(truncatedYuan, minPrecision)
    return trim ? temp.replace(/\.?0+$/, "") : temp
  } else {
    const temp = math.format(parseFloat(truncatedYuan), { notation: "fixed", precision: minPrecision })
    return trim ? temp.replace(/\.?0+$/, "") : temp
  }
}

/**
 * 转换元为分
 * @param number
 * @returns
 */
export function convertYuanToCents(yuan: number): number {
  const bignumberResult = math.multiply(math.bignumber(yuan), math.bignumber(100))
  return math.number(bignumberResult.toString())
}
